// Copyright (c) Docugami, Inc. All rights reserved.

import axios from "axios";

export const isNetworkError = (error: Error): boolean => (axios.isAxiosError(error) && !error.response) || error.message.toLowerCase().includes('network error')